import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import classNames from 'classnames';
import showBarrier from '../../../utils/showBarrier';
import { tabsMapping, restrictedPagesByCustomMetering } from '../helpers/tabNames';

const NavLink = ({
    url, hash, tabName, tabUrl, activeClassName, cssClasses, userRole, pageName, location: { pathname },
}) => {
    const tabNameText = tabsMapping(tabName);
    const page = restrictedPagesByCustomMetering[pageName];
    const shouldUseCustomMetering = page ? page
        .includes(tabNameText.toLowerCase().replace(' ', '_')) &&
        tabNameText !== 'form' : false;

    const splittedPaths = pathname.split('/');
    const activeTab = splittedPaths[splittedPaths.length - 1];

    if (
        activeTab === tabUrl ||
        // for the case where form tab is active, but there is no /form in the URL
        (tabName === 'form' && !tabUrl && activeTab !== 'form')
    ) {
        return (<span
            className={classNames('ui-tabs__tab', 'pp-tabs__tab', ...cssClasses, activeClassName)}
            data-tab-name={tabNameText}
            activeClassName={activeClassName}
        >
            {tabNameText}
        </span>);
    }

    return (
        <Link
            to={`${url}/${tabUrl}${hash}`}
            className={classNames('ui-tabs__tab', 'pp-tabs__tab', ...cssClasses)}
            data-tab-name={tabNameText}
            activeClassName={activeClassName}
            onClick={event => showBarrier(
                event,
                `${url}/${tabUrl}${hash}`,
                tabNameText,
                shouldUseCustomMetering,
                userRole,
                pageName
            )}
        >
            {tabNameText}
        </Link>
    );
};

NavLink.defaultProps = {
    cssClasses: [],
    location: {
        pathname: '',
    },
};

NavLink.propTypes = {
    url: PropTypes.string.isRequired,
    hash: PropTypes.string,
    tabName: PropTypes.string.isRequired,
    tabUrl: PropTypes.string.isRequired,
    activeClassName: PropTypes.string.isRequired,
    cssClasses: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string, PropTypes.bool,
    ])),
    userRole: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
    location: {
        pathname: PropTypes.string.isRequired,
    },
};

export default withRouter(NavLink);



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/NavLink.jsx